export const ASSET_TYPES = [
  {
    asset_type_id: "0c7ca444-ed80-11e2-9273-667829626f0a",
    admin_desc: "Pump",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "1c2aa72e-ed80-11e2-9273-667829626f0a",
    admin_desc: "Steam Trap",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "2d9b6fe8-ed80-11e2-9273-667829626f0a",
    admin_desc: "Switch",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "3d071c66-ed80-11e2-9273-667829626f0a",
    admin_desc: "Transformer",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "4b895cd6-ed80-11e2-9273-667829626f0a",
    admin_desc: "UPS",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "5b13ab20-ed80-11e2-9273-667829626f0a",
    admin_desc: "Valve",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "5695EC05-E87A-4C21-9552-CE615B389384",
    admin_desc: "Fan",
    created_date: "2019-01-18 12:35:44",
    modified_date: "2019-01-18 12:35:44"
  },
  {
    asset_type_id: "99555C2C-BC51-11E2-9678-15B654818C3B",
    admin_desc: "Boiler",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "99555CB8-BC51-11E2-9678-15B654818C3B",
    admin_desc: "Breaker",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "99555CCC-BC51-11E2-9678-15B654818C3B",
    admin_desc: "Busbar",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "99555CD6-BC51-11E2-9678-15B654818C3B",
    admin_desc: "Connector",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "99555EB6-BC51-11E2-9678-15B654818C3B",
    admin_desc: "Controller",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "99555EC0-BC51-11E2-9678-15B654818C3B",
    admin_desc: "Chiller",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "99555EC1-BC51-11E2-9678-15B654818C3B",
    admin_desc: "Disconnect",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "99555ECA-BC51-11E2-9678-15B654818C3B",
    admin_desc: "Fuse",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "99555ED4-BC51-11E2-9678-15B654818C3B",
    admin_desc: "Electrical Panel",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "99555ED5-BC51-11E2-9678-15B654818C3B",
    admin_desc: "Generator",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "99555ED6-BC51-11E2-9678-15B654818C3B",
    admin_desc: "Heater",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "99555EDE-BC51-11E2-9678-15B654818C3B",
    admin_desc: "Motor",
    created_date: "2014-11-04 22:14:05",
    modified_date: "2014-11-04 22:14:05"
  },
  {
    asset_type_id: "CA8482D6-B18B-4E3E-BF5C-251A79274EAE",
    admin_desc: "Compressor",
    created_date: "2019-01-18 12:35:44",
    modified_date: "2019-01-18 12:35:44"
  },
  {
    asset_type_id: "DFE97E8E-4A5D-4975-BC44-AD84EE5253BE",
    admin_desc: "Blower",
    created_date: "2019-01-18 12:35:44",
    modified_date: "2019-01-18 12:35:44"
  }
];

export const ASSET_SEVERITIES = [
  {
    severityId: "52D4BCCE-BC52-11E2-9678-15B654818C3B",
    adminDesc: "Good",
    severityColor: "green",
    sortOrder: 1
  },
  {
    severityId: "52D4BD28-BC52-11E2-9678-15B654818C3B",
    adminDesc: "Satisfactory",
    severityColor: "yellow",
    sortOrder: 2
  },
  {
    severityId: "52D4BD32-BC52-11E2-9678-15B654818C3B",
    adminDesc: "Unsatisfactory",
    severityColor: "orange",
    sortOrder: 3
  },
  {
    severityId: "52D4BD3C-BC52-11E2-9678-15B654818C3B",
    adminDesc: "Unacceptable",
    severityColor: "red",
    sortOrder: 4
  },
  {
    severityId: "F9CC6C2B-1C7A-4BB4-88D4-353FBFD049F0",
    adminDesc: "Unassigned",
    severityColor: "white",
    sortOrder: 0
  }
];

export const severityUnassigned = "F9CC6C2B-1C7A-4BB4-88D4-353FBFD049F0";
export const severityGood = "52D4BCCE-BC52-11E2-9678-15B654818C3B";
export const severitySatisfactory = "52D4BD28-BC52-11E2-9678-15B654818C3B";
export const severityUnsatisfactory = "52D4BD32-BC52-11E2-9678-15B654818C3B";
export const severityUnacceptable = "52D4BD3C-BC52-11E2-9678-15B654818C3B";

export const ALARM_TYPES = [
  { typeId: 0 },
  { typeId: 1 },
  { typeId: 2 },
  { typeId: 3 },
  { typeId: 4 },
  { typeId: 5 }
];
export const TOP_ALARM_TYPE_CONSTANT = 5;
